module.exports = __webpack_public_path__ + "media/images/new-product-icon-6bf22e98.png";